/**
 * GPS设备异常提示
 */
import React, { useState } from 'react';
import { Card, Form, Row, Col, Button, Input, Select } from 'antd';
import dayjs from 'dayjs';
import DatePicker from '@/components/datePicker';
import CommonTable from '@/components/commonTable';
import ExportButton from '@/components/exportButton';
import { useTable } from '@/utils/useTable';
import { formSearchGutter } from '@/constants/common';
import {
  gpsDeviceExceptionListRequest,
  gpsDeviceExceptionListRequestPath
} from '@/service/gpsDevice';
import styles from '@/styles/pageContent.module.scss';

const { Option } = Select;

const GpsDeviceErrorTip = () => {
  const [searchParams, setSearchParams] = useState<any>({});
  const [form] = Form.useForm();

  const { page, limit, loading, data, totalCount, onPageChange } = useTable({
    requestFunc: gpsDeviceExceptionListRequest,
    initPageSize: 5,
    searchParams
  });

  // 处理搜索参数(将表单字段名映射为接口字段名)
  const operateSearchParams = (values: any, isExport?: boolean) => {
    const newParams: any = {};
    newParams.day = values.monitorDate ? dayjs(values.monitorDate).format('YYYY-MM-DD') : undefined;
    newParams.plateNumber = (values.plateNumber || '').trim() || undefined;
    newParams.deviceId = (values.deviceSn || '').trim() || undefined;
    newParams.faultDeviceTypeName = values.errorType || undefined;
    newParams.billingModeName = values.billingMode || undefined;
    if (isExport) {
      newParams.export = true;
    }
    Object.keys(newParams).forEach(key => {
      if (newParams[key] === undefined || newParams[key] === '') {
        delete newParams[key];
      }
    });
    return newParams;
  };

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateSearchParams(values);
    setSearchParams(newSearchParams);
  };

  // 重置
  const onReset = () => {
    form.resetFields();
    setSearchParams({});
  };

  // 获取导出参数
  const getExportParams = () => {
    const values = form.getFieldsValue();
    return operateSearchParams(values, true);
  };

  const columns = [
    { title: '系统监测日期', dataIndex: 'day', width: 120 },
    { title: '车牌号', dataIndex: 'plateNumber', width: 120 },
    { title: '设备SN', dataIndex: 'deviceId', width: 150 },
    { title: '异常类型', dataIndex: 'faultDeviceTypeDesc', width: 140 },
    { title: '计费模式', dataIndex: 'billingModeDesc', width: 100 },
    { title: '监测结论', dataIndex: 'remark', width: 500, ellipsis: { showTitle: false } },
  ];

  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Form form={form} onFinish={onSearch} autoComplete="off">
        <Row gutter={formSearchGutter}>
          <Col span={4}>
            <Form.Item label="系统监测日期" name="monitorDate">
              <DatePicker placeholder="请选择系统监测日期" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="车牌号" name="plateNumber">
              <Input placeholder="请输入车牌号（模糊搜索）" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="设备SN" name="deviceSn">
              <Input placeholder="请输入设备SN" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="异常类型" name="errorType">
              <Select placeholder="请选择异常类型" allowClear>
                <Option value="FUNCTION_DEVICE">功能设备异常</Option>
                <Option value="GPS_DEVICE">GPS监测设备异常</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="计费模式" name="billingMode">
              <Select placeholder="请选择计费模式" allowClear>
                <Option value="REGULAR">常规模式</Option>
                <Option value="UBP">UBP模式</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item>
              <div className={styles.searchBox} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" htmlType="submit">搜索</Button>
                <Button onClick={onReset}>重置</Button>
                <ExportButton
                  url={gpsDeviceExceptionListRequestPath}
                  fileName="GPS设备异常提示"
                  getParamsFunc={getExportParams}
                  requestMethod="POST"
                  permissionKey="/car-admin/gps-device-manage/export"
                />
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '50'],
          showQuickJumper: true,
          showTotal: (total: number) => `共 ${total} 条`
        }}
        bordered
        loading={loading}
        scroll={{ x: 1200 }}
      />
    </Card>
  );
};

export default GpsDeviceErrorTip;
